"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaOrderApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaOrderApiClient extends BaseApiClient_1.BaseApiClient {
    async retrieveOrders(queryParams) {
        const path = `/v1.1/orders`;
        return await this.request("get", path, queryParams, undefined);
    }
    async updateOrders(orderDtoList) {
        const path = `/v1.1/orders`;
        return await this.request("post", path, undefined, orderDtoList);
    }
    async retrieveChannelPurchases(queryParams) {
        const path = `/v1.1/orders/channelpurchases`;
        return await this.request("get", path, queryParams, undefined);
    }
    async deleteCustomFieldDefinitions(deleteCustomFieldDefs) {
        const path = `/v1.1/orders/customfielddefinitions`;
        return await this.request("delete", path, undefined, deleteCustomFieldDefs);
    }
    async retrieveCustomFieldDefinitions(queryParams) {
        const path = `/v1.1/orders/customfielddefinitions`;
        return await this.request("get", path, queryParams, undefined);
    }
    async createCustomFieldsDefinitions(putCustomFieldDefinitions) {
        const path = `/v1.1/orders/customfielddefinitions`;
        return await this.request("put", path, undefined, putCustomFieldDefinitions);
    }
    async retrieveOrder(orderId) {
        const path = `/v1.1/orders/${orderId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async deleteCustomFieldValues(orderId, deleteCustomFieldValues) {
        const path = `/v1.1/orders/${orderId || ""}/customfieldvalues`;
        return await this.request("delete", path, undefined, deleteCustomFieldValues);
    }
    async retrieveCustomFieldValues(orderId) {
        const path = `/v1.1/orders/${orderId || ""}/customfieldvalues`;
        return await this.request("get", path, undefined, undefined);
    }
    async createCustomField(orderId, putCustomFieldValues) {
        const path = `/v1.1/orders/${orderId || ""}/customfieldvalues`;
        return await this.request("put", path, undefined, putCustomFieldValues);
    }
    async deleteOrderItems(orderId, queryParams) {
        const path = `/v1.1/orders/${orderId || ""}/orderitems`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async updateOrderItems(postOrderItems, orderId) {
        const path = `/v1.1/orders/${orderId || ""}/orderitems`;
        return await this.request("post", path, undefined, postOrderItems);
    }
    async addOrderItems(putOrderItems, orderId) {
        const path = `/v1.1/orders/${orderId || ""}/orderitems`;
        return await this.request("put", path, undefined, putOrderItems);
    }
    async createOrders(putOrderList) {
        const path = `/v1/order`;
        return await this.request("put", path, undefined, putOrderList);
    }
    async retrieveLabels(orderId) {
        const path = `/v1/order/${orderId || ""}/labels`;
        return await this.request("get", path, undefined, undefined);
    }
    async splitsAnOrder(postOrderSplit, orderId) {
        const path = `/v1/order/${orderId || ""}/split`;
        return await this.request("post", path, undefined, postOrderSplit);
    }
    async removeAdditionalPackagesFromOrder(orderId, queryParams) {
        const path = `/v1/orders/additionalpackages/${orderId || ""}`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async getAdditionalPackagesForOrder(orderId) {
        const path = `/v1/orders/additionalpackages/${orderId || ""}`;
        return await this.request("get", path, undefined, undefined);
    }
    async updateAdditionalPackagesOnOrder(orderId, postAdditionalPackageList) {
        const path = `/v1/orders/additionalpackages/${orderId || ""}`;
        return await this.request("post", path, undefined, postAdditionalPackageList);
    }
    async addAdditionalPackagesToOrder(orderId, putAdditionalPackageList) {
        const path = `/v1/orders/additionalpackages/${orderId || ""}`;
        return await this.request("put", path, undefined, putAdditionalPackageList);
    }
    async cancelOrders(queryParams) {
        const path = `/v1/orders/cancel`;
        return await this.request("post", path, queryParams, undefined);
    }
    async updateOrderNotes(orderNotes) {
        const path = `/v1/orders/notes`;
        return await this.request("post", path, undefined, orderNotes);
    }
    async changeTheOrderStatusToOnhold(queryParams) {
        const path = `/v1/orders/onhold`;
        return await this.request("post", path, queryParams, undefined);
    }
    async restoreOrdersFromOnHoldOrCancelledStatus(orderIds) {
        const path = `/v1/orders/restore`;
        return await this.request("post", path, undefined, orderIds);
    }
    async sendOrdersToFulfillment(queryParams) {
        const path = `/v1/orders/sendtofulfillment`;
        return await this.request("post", path, queryParams, undefined);
    }
    async removeLabelsFromOrder(orderId, queryParams) {
        const path = `/v1/orders/${orderId || ""}/labels`;
        return await this.request("delete", path, queryParams, undefined);
    }
    async assignLabelsForOrder(orderId, queryParams) {
        const path = `/v1/orders/${orderId || ""}/labels`;
        return await this.request("post", path, queryParams, undefined);
    }
}
exports.SkubanaOrderApiClient = SkubanaOrderApiClient;
